"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FuturesBalancesTableHeader = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _Input = require("../../form/Input");
var _Checkbox = require("../../form/Checkbox/Checkbox");
var _FuturesTransferButton = _interopRequireDefault(require("../../MarginTransferAssetModal/FuturesTransferButton"));
require("./FuturesBalancesTableHeader.css");
var _APDatePicker = _interopRequireDefault(require("../../common/APDatePicker/APDatePicker"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var createCls = (0, _cssClassesHelper.getBEMClasses)('futures-balances-table-header');

// Utility to compare dates or nulls
function isSameDate(a, b) {
  if (a === b) return true;
  if (a == null || b == null) return false;
  return a instanceof Date && b instanceof Date && a.getTime() === b.getTime();
}
var useDebouncedEffect = function useDebouncedEffect(effect, deps, delay) {
  (0, _react.useEffect)(function () {
    var handler = setTimeout(function () {
      return effect();
    }, delay);
    return function () {
      return clearTimeout(handler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [].concat(_toConsumableArray(deps), [delay]));
};
var FuturesBalancesTableHeader = exports.FuturesBalancesTableHeader = function FuturesBalancesTableHeader(_ref) {
  var onSearch = _ref.onSearch,
    searchText = _ref.searchText,
    isSmallAmountsChecked = _ref.isSmallAmountsChecked,
    onHideSmallAmounts = _ref.onHideSmallAmounts,
    selectedTab = _ref.selectedTab,
    onTabChange = _ref.onTabChange,
    getFuturesPositionHistory = _ref.getFuturesPositionHistory,
    accountId = _ref.accountId,
    OMSId = _ref.OMSId;
  var _useTranslation = (0, _reactI18next.useTranslation)('futures'),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)({
      startDate: null,
      endDate: null
    }),
    _useState2 = _slicedToArray(_useState, 2),
    dateRange = _useState2[0],
    setDateRange = _useState2[1];
  var prevRange = (0, _react.useRef)({
    startDate: null,
    endDate: null
  });
  useDebouncedEffect(function () {
    var startChanged = !isSameDate(dateRange.startDate, prevRange.current.startDate);
    var endChanged = !isSameDate(dateRange.endDate, prevRange.current.endDate);
    if (startChanged || endChanged) {
      getFuturesPositionHistory(accountId, OMSId, dateRange.startDate, dateRange.endDate);
      prevRange.current = _objectSpread({}, dateRange);
    }
  }, [dateRange, accountId, OMSId, getFuturesPositionHistory], 200);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: createCls()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "futures-balances-tabs"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: selectedTab === 'assets' ? 'active' : '',
    onClick: function onClick() {
      return onTabChange('assets');
    }
  }, t('Assets')), /*#__PURE__*/_react["default"].createElement("button", {
    className: selectedTab === 'positions' ? 'active' : '',
    onClick: function onClick() {
      return onTabChange('positions');
    }
  }, t('Positions')), /*#__PURE__*/_react["default"].createElement("button", {
    className: selectedTab === 'positionHistory' ? 'active' : '',
    onClick: function onClick() {
      return onTabChange('positionHistory');
    }
  }, t('Position History'))), selectedTab === 'assets' && /*#__PURE__*/_react["default"].createElement("div", {
    className: createCls('table-header-container')
  }, /*#__PURE__*/_react["default"].createElement(_Checkbox.Checkbox, {
    label: t('Hide Small Amounts'),
    checked: isSmallAmountsChecked,
    onChange: onHideSmallAmounts
  }), /*#__PURE__*/_react["default"].createElement(_FuturesTransferButton["default"], null)), /*#__PURE__*/_react["default"].createElement(_Input.SearchInput, {
    className: createCls('search'),
    placeholder: t('Search By'),
    value: searchText,
    onSearch: onSearch,
    size: "small"
  }), selectedTab === 'positionHistory' && /*#__PURE__*/_react["default"].createElement("div", {
    className: createCls('date-pickers-container')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: createCls('date-pickers-container__label')
  }, t('Date range:')), /*#__PURE__*/_react["default"].createElement(_APDatePicker["default"], {
    name: "startDate",
    maxDate: dateRange.endDate && dateRange.endDate < new Date() ? dateRange.endDate : new Date(),
    label: null,
    value: dateRange.startDate,
    onClear: function onClear() {
      return setDateRange(_objectSpread(_objectSpread({}, dateRange), {}, {
        startDate: null
      }));
    },
    customChange: function customChange(value) {
      var normalizedValue = value === '' ? null : value;
      if (normalizedValue instanceof Date || normalizedValue === null) {
        setDateRange(_objectSpread(_objectSpread({}, dateRange), {}, {
          startDate: normalizedValue
        }));
      }
    }
  }), /*#__PURE__*/_react["default"].createElement(_APDatePicker["default"], {
    name: "endDate",
    minDate: dateRange.startDate,
    maxDate: new Date(),
    label: null,
    value: dateRange.endDate,
    onClear: function onClear() {
      return setDateRange(_objectSpread(_objectSpread({}, dateRange), {}, {
        endDate: null
      }));
    },
    customChange: function customChange(value) {
      var normalizedValue = value === '' ? null : value;
      if (normalizedValue instanceof Date || normalizedValue === null) {
        setDateRange(_objectSpread(_objectSpread({}, dateRange), {}, {
          endDate: normalizedValue
        }));
      }
    }
  })));
};